module.exports = __webpack_public_path__ + "img/26.222e7eae.webp";